import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { getClassAndTitle, getClassAndTitleInverted } from '../../utils';
export const Value = ({ value, warning, max, inverted }) => {
    if (warning == null || max == null) {
        return _jsx("span", { children: value });
    }
    const { className, title } = inverted
        ? getClassAndTitleInverted(value, warning, max)
        : getClassAndTitle(value, warning, max);
    return _jsxs(_Fragment, { children: [_jsx("span", { className: className, children: value }), _jsx("span", { className: "tooltip", children: title })] });
};
